import { configOpeningHours } from "@/storage/setting/configOpeningHours"
import { computed } from "vue"

export const isPickup = computed(() => {
    const openingHours = configOpeningHours.value

    if (
        openingHours &&
        openingHours.delivery_service &&
        openingHours.delivery_service.length > 0
    ) {
        return 'Horaires / Livraison'
    }

    return 'Horaires'
})